<template>
  <div class="page-employee">
    <div class="page-employee__wrapper">
      <div class="page-employee__container">
        <div class="page-employee__container-close" @click="$emit('closeEmployee')">
          <i class="icon-close"></i>
        </div>
        <keep-alive>
          <component :is="currentComponent" @nextForm="nextForm" v-bind="dynamicProps" />
        </keep-alive>
      </div>

      <div class="page-employee__nav">
        <div class="page-employee__nav-title">{{ currentComponentTitle }}</div>
        <div class="page-employee__nav-line"></div>
        <div class="page-employee__nav-close" @click="$emit('closeEmployee')">
          <i class="icon-close"></i>
        </div>

        <div class="page-employee__nav-circles">
          <div
            class="page-employee__nav-option"
            :class="{ selected: currentComponent == 'Employee' }"
            @click="currentComponent = 'Employee'"
          >
            <div class="page-employee__nav-circle"></div>
            <div class="option-title">Datos Personales</div>
          </div>

          <div
            class="page-employee__nav-option"
            :class="{ selected: currentComponent == 'ConceptosRemunerativos' }"
            @click="currentComponent = 'ConceptosRemunerativos'"
          >
            <div class="page-employee__nav-circle"></div>
            <div class="option-title">Conceptos Remunerativos Fijos</div>
          </div>

          <div
            class="page-employee__nav-option"
            :class="{ selected: currentComponent == 'BonoComision' }"
            @click="currentComponent = 'BonoComision'"
          >
            <div class="page-employee__nav-circle"></div>
            <div class="option-title">Conceptos Remunerativos Variables</div>
          </div>

          <div
            class="page-employee__nav-option"
            :class="{ selected: currentComponent == 'Descuentos' }"
            @click="currentComponent = 'Descuentos'"
          >
            <div class="page-employee__nav-circle"></div>
            <div class="option-title">Descuentos</div>
          </div>
          <div
            class="page-employee__nav-option"
            :class="{ selected: currentComponent == 'VacationInitial' }"
            @click="currentComponent = 'VacationInitial'"
          >
            <div class="page-employee__nav-circle"></div>
            <div class="option-title">Data inicial de vacaciones</div>
          </div>
          <div
            class="page-employee__nav-option"
            :class="{ selected: currentComponent == 'History' }"
            @click="currentComponent = 'History'"
          >
            <div class="page-employee__nav-circle"></div>
            <div class="option-title">Histórico</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  components: {
    Employee: () => import("@/components/empleado/Employee"),
    BonoComision: () => import("@/components/empleado/BonoComision"),
    Descuentos: () => import("@/components/empleado/Descuentos"),
    ConceptosRemunerativos: () => import("@/components/empleado/ConceptosRemunerativos"),
    History: () => import("@/components/empleado/History"),
    VacationInitial: () => import("@/components/empleado/VacationInitial"),
  },
  data() {
    return {
      currentComponent: "Employee",
    };
  },

  computed: {
    currentComponentTitle() {
      switch (this.currentComponent) {
        case "Employee":
          return "Información Personal";
          break;
        case "ConceptosRemunerativos":
          return "Conceptos Remunerativos Fijos";
          break;
        case "BonoComision":
          return "Conceptos Remunerativos Variables";
          break;
        case "Descuentos":
          return "Descuentos";
          break;
        case "Vacation Initial":
          return "Data inicial de vacaciones";
          break;
        case "History":
          return "Histórico";
          break;
      }
    },

    dynamicProps() {
      if (this.currentComponent == "Employee") return { item: this.item };
      else {
        return { id: this.item.id };
      }
    },
  },

  methods: {
    nextForm() {
      if (this.currentComponent == "Employee") this.currentComponent = "BonoComision";
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS
.selected {
  .page-employee__nav-circle {
    background-color: $b-emph !important;
    border: 1px solid $b-emph !important;
  }
  .option-title {
    color: $b-blue;
    font-weight: 600;
  }
}

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.page-employee {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 600;
  background-color: rgba(46, 54, 103, 0.75);
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    box-shadow: 0 0 2000px rgba($b-blue-dark, 0.75) inset;
    background: inherit;
  }

  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    @include mq($md) {
      // width: 90%;
      // max-width: 75rem;
      // height: 90%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    @include mq($lg) {
      max-width: 80rem;
      max-height: 51rem;
    }
  }

  &__nav {
    position: absolute;
    top: 0;
    left: 0;
    height: 6rem;
    width: 100%;
    background-color: #eceff8;
    display: flex;
    justify-content: center;
    align-items: center;
    @include mq($md) {
      height: 100%;
      width: 18rem;
      border-top-left-radius: 9px;
      border-bottom-left-radius: 9px;
    }

    &-line {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      width: 100%;
      background-color: $b-blue;
      @include mq($md) {
        top: 15%;
        transform: rotate(90deg);
        transform-origin: left;
        margin-left: 3.5rem;
        width: 100%;
      }
    }

    &-close {
      position: absolute;
      right: 1rem;
      top: 1rem;
      color: $b-orange;
      font-size: 1.2rem;
      @include mq($md) {
        display: none;
      }
    }

    &-title {
      margin-top: -1rem;
      color: $b-orange;
      font-weight: 600;
      font-size: 1.1rem;
      @include mq($md) {
        display: none;
      }
    }

    &-circles {
      position: absolute;
      bottom: -1.5rem;
      left: 50%;
      width: 20rem;
      transform: translateX(-50%);
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      z-index: 3;
      @include mq($md) {
        flex-direction: column;
        top: 12%;
        left: 50%;
        bottom: unset;
        width: 100%;
        height: 20rem;
        padding-left: 2rem;
      }
    }
    &-option {
      @include mq($md) {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        cursor: pointer;
      }
    }

    &-circle {
      height: 3rem;
      width: 3rem;
      border: 1px solid $b-blue;
      background-color: #fff;
      border-radius: 100%;
      transition: all 0.3s ease-out;
    }
  }

  &__container {
    position: absolute;
    top: 6rem;
    left: 0;
    height: calc(100% - 6rem);
    width: 100%;
    background-color: #f2f2f2;
    background-color: #fff;
    padding: 2rem 0 0 0;
    overflow-y: scroll;
    scrollbar-width: none;

    @include mq($md) {
      overflow-y: auto;
      border-top-right-radius: 9px;
      border-bottom-right-radius: 9px;
    }
    &-close {
      display: none;
      @include mq($md) {
        display: block;
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        color: $b-orange;
        font-size: 2rem;
        cursor: pointer;
      }
    }
    @include mq($md) {
      width: calc(100% - 18rem);
      left: 18rem;
      height: 100%;
      top: 0;
    }
  }
}

.option-title {
  display: none;
  @include mq($md) {
    display: block;
    font-size: 1rem;
    width: 11rem;
    margin-left: 1rem;
    line-height: 1rem;
  }
}
</style>
